import { makeStyles } from '@fluentui/react-components';

export const useReportingPageStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '10px',
    },
});
